<script>
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";
import firebase from "firebase/compat/app";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import _ from "lodash";
import {
  getStorage,
  uploadBytes,
  ref,
  deleteObject,
  getDownloadURL,
} from "firebase/storage";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import VueRouter from "vue-router";
// import Client from "../components/Client.vue";

const uuid = require("uuid");

export default {
  components: {
    LoginComponent,
    SignupComponent,
    vueDropzone: vue2Dropzone,
    Loader: () => import("@/components/Loader.vue"),
    RentalInfo: () => import("@/components/Item/RentalInfo.vue"),
  },

  props: ["id"],
  data() {
    return {
      selectedImage: "", // Store the URL of the selected image
      userWatch: true,
      user: {},
      continueMessageLenderAfterLogin: false,
      loginDialog: false,
      signupDialog: false,
      bp1: false,
      loading: false,
      menu1: false,
      verified: false,
      listingsCount: null,
      avatarPic: "",
      hasAvatar: true,
      uid: null,
      item: {},
      bookingsCount: null,
      booker: [],
      showDialog: false,
      overlay: false,
      itemDialog: false,
      rating: 4,
      registerDialog: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        // acceptedFiles: '.jpeg,.jpg,.png,.gif',
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: false,

        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
        <br>
        <p class='text-default'>  Uploaded Images will be shown Below</p>
          `,
        headers: { "My-Awesome-Header": "header value" },
      },
      max: 500,
      deleteDialog: false,
      enabled: false,
      Nabled: false,
      dialog: false,
      startDate: null,
      removeFile: null,
      showLoadingForUpdateItem: false,
      availabilty: false,
      editedMonthlyFee: "",
      editedDescription: "",
      on: "",
      recomendedWeekly: "00",
      recomendedMonthly: "00",
      editedWeeklyFee: "",
      editedDailyFee: "",
      editedDeliveryFee: "",
      editedTitle: "",
      editedCategory: "",
      editedDeposit: "",
      editedCondition: "",
      editedMinperiodLength: "",
      editedMinDays: "",
      strapper: {},
      editedArea: "",
      editedLocation: "",
      period: "",
      periodLength: "",
      allConditions: [
        "Like New, no signs of use",
        "Good, Minor signs of use, everything works",
        "Fair, Medium signs of use, everything works",
        "Worn, Heavy signs of use, everything works",
      ],
      i: "",
      periodOptions: ["Day(s)", "Week(s)", "Month(s)"],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Be more descriptive.",
      },
      allCategories: [
        "Technology",
        "Transportation",
        "Household living",
        "DIY",
        "Exercise",
        "Music and Audio",
      ],
      items: [
        {
          icon: "mdi-heart-outline",
          text: "Like",
          action: "likeItem",
        },
        {
          icon: "mdi-facebook",
          text: "Share",
          action: "shareItem",
        },
        {
          icon: "mdi-link",
          text: "Copy link",
          action: "copyLink",
        },
        // {
        //   icon: "mdi-message-processing-outline",
        //   text: "Chat with Seller",
        //   action: "chatWithSeller",
        // },
      ],
      category: null,
      area: null,
      savedLocations: [],
    };
  },

  created() {
    console.log(this.$route.params.itemName);
    const itemName = this.$route.params.itemName.replace(/\s+/g, "-");
    console.log(itemName);
    this.fetchItem(itemName);
  },

  computed: {
    // reviews() {
    //   // console.log('all reviews: ', this.$store.getters.loadedReviews);
    //   return this.$store.getters.loadedReviews.filter(
    //     (review) =>
    //       review.itemId === this.item.id && review.reviewType === "item"
    //   );
    // },

    // rateItems() {
    //   let array = [];
    //   this.$store.getters.loadedItems.filter((item) => {
    //     let t =
    //       item.userID === this.item.userID && item.rating_count != undefined;
    //     if (t == true) {
    //       array.push(item);
    //     }

    //     // return count
    //   });
    //   // console.log(array);
    //   let count = 0;
    //   for (let i = 0; i < array.length; i++) {
    //     console.log("test");
    //     count = Number(array[i].rating_count) + count;
    //   }
    //   return count;
    // },

    isVerified() {
      firebase
        .firestore()
        .collection("users")
        .doc(this.item.userID)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          return (this.verified = querySnapshot.data().verified);
        });
      // console.log("verified: ", this.verified);
      return this.verified;
    },

    strappDate() {
      firebase
        .firestore()
        .collection("users")
        .doc(this.item.userID)
        .get()
        .then((querySnapshot) => {
          //           this.avatar =  querySnapshot.data().avatar
          // console.log(this.avatar)
          if (querySnapshot.data().createdAt) {
            let d = querySnapshot.data().createdAt.seconds;
            console.log(d);
            var date = new Date(d * 1000).toString();
            date = date.substring(4, 15);
            console.log("dates:", date);

            return (this.startDate = date);
          } else {
            console.log("datesss:");
            return (this.startDate = null);
          }
        });
      // console.log("start daTE:", this.startDate);
      return this.startDate;
    },

    async avatar() {
      this.uid = this.item.userID;
      this.hasAvatar = false;
      await firebase
        .firestore()
        .collection("users")
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          console.log(querySnapshot.data());
          return (this.avatarPic = querySnapshot.data().avatar);
        });
      // console.log("avater", this.avatarPic);

      if (
        this.avatarPic != undefined &&
        this.avatarPic != "" &&
        this.avatarPic != null
      ) {
        // console.log("has avatar");
        this.hasAvatar = true;
      }
      return this.avatarPic;
    },

    bookingsMade() {
      // console.log(this.$route.query);
      return _.filter(this.$store.getters.loadedBookings, {
        borrowerID: this.item.userID,
      }).length;
    },

    bookingsReceived() {
      return _.filter(this.$store.getters.loadedBookings, {
        lenderID: this.item.userID,
      }).length;
    },

    items() {
      return this.$store.getters.loadedItems.filter((item) => {
        return item.userID === this.item.userID;
      }).length;
    },

    // item() {
    //   console.log("item loop");
    //   var a = this.$store.getters.loadedItems.filter((item) => {
    //     return (
    //       item.itemName.replace(/\s+/g, "-") ===
    //       this.$route.params.itemName.replace(/\s+/g, "-")
    //     );
    //   });

    //   return a[0];
    // },
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    progress() {
      return Math.min(100, this.editedDescription.length * 1.6);
    },
    color() {
      return ["red", "orange", "green"][Math.floor(this.progress / 40)];
    },
    userIsAuthenticated() {
      console.log("authenticated user");
      this.user = this.$store.getters.user;
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    // user() {
    //   // console.log(item.userID);
    //   firebase
    //     .firestore()
    //     .collection('users')
    //     .doc(item.userID)
    //     .get()
    //     // .then(function(querySnapshot) {
    //     //   console.log(querySnapshot);
    //     // })
    //     .catch(function (error) {
    //       // console.log("Error getting documents: ", error);
    //     });

    //   return item.userID === this.$store.getters.user.uid;

    // },
    userIsCreator() {
      console.log("user is creator loop");
      if (!this.userIsAuthenticated) {
        return false;
      }

      return this.$store.getters.user.id === this.item.userID;
    },
  },
  watch: {
    async user() {
      console.log("watch user loop");
      if (this.continueMessageLenderAfterLogin && this.userWatch == true) {
        this.userWatch = false;
        this.loading = true;
        await this.$store
          .dispatch("loadRooms", this.user)
          .then(async (response) => {
            localStorage.setItem("chatUser", JSON.stringify(this.item));
            localStorage.setItem("chatUserAvatar", this.avatarPic);
            console.log("loaded rooms on async", response);
            await this.delay(1000);
            this.loading = false;
            this.$router.push("/inbox");
          });
      }
    },

    editedDailyFee: function (val) {
      // if daily fee === 00
      this.editedDailyFee = val;
      this.recomendedWeekly = val * 4;
      this.recomendedMonthly = val * 12;
    },
  },

  methods: {
    likeItem() {
      // Handle like item functionality
    },
    shareItem() {
      // Handle share item functionality
    },
    copyLink() {
      // Handle copy link functionality
    },
    chatWithSeller() {
      // Handle chat with seller functionality
    },
    changeSelectedImage(imageUrl) {
      this.selectedImage = imageUrl; // Update the selected image URL
    },
    async fetchItem(itemName) {
      // console.log("fetch item GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG");
      try {
        const db = getFirestore();
        const q = query(
          collection(db, "salesItems"),
          where("itemName", "==", itemName)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          this.item = doc.data();
          this.selectedImage = this.item.images[0];
          console.log("success", this.item);
        } else {
          console.log("Item not found!");
        }
      } catch (error) {
        console.error("Error fetching item:", error);
      }
    },

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    toInbox: function (item) {
      console.log("to inbox");
      localStorage.setItem("chatUser", JSON.stringify(item));
      localStorage.setItem("chatUserAvatar", this.avatarPic);
      if (!this.userIsAuthenticated) {
        this.loginDialog = true;
        this.continueMessageLenderAfterLogin = true;
      } else {
        this.$router.push("/inbox");
      }
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setEditImages() {
      const item = this.item;
      const images = item.images;
      this.availabilty = item.availabilty;
      for (var img in images) {
        var url = images[img];
        this.$refs.imgEditDropZone.manuallyAddFile(url);
      }
    },
    // TODO
    async afterComplete(upload) {
      try {
        //save image
        let file = upload;
        console.log("file:", file);
        const storage = getStorage();
        var imageUrl = uuid.v1();
        const imageRef = ref(storage, `items/${imageUrl}.png`);

        // const snapshot = await uploadString(imageRef, file, metadata);
        const snapshot = await uploadBytes(imageRef, file, "data_url");
        const downloadURL = await getDownloadURL(snapshot.ref);
        console.log("snapshoot:", snapshot);
        this.item.images.push({ src: downloadURL });
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone.removeFile(upload);
    },
    remove(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "This image will be removed immediately and you can't revert this ",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          // var ref = firebase.storage().refFromURL(image.src);
          const storage = getStorage();
          console.log("SRC:", image.src);
          const imageRef = ref(storage, image.src);
          deleteObject(imageRef)
            .then(() => {
              // File deleted successfully
              Toast.fire({
                title: "Image deleted successfully",
              });
              this.item.images.splice(index, 1);
            })
            .catch((error) => {
              // Uh-oh, an error occurred!
            });
        }
      });
    },

    onSaveChanges() {
      this.showLoadingForUpdateItem = true;
      this.item.availabilty = this.availabilty;
      this.$store
        .dispatch("updateItemData", {
          id: this.item.id,
          itemName: this.editedTitle || this.item.itemName,
          itemDescription: this.editedDescription,
          deposit: this.editedDeposit,
          dailyFee: this.editedDailyFee,
          availability: this.editedAvailability,
          deliveryFee: this.editedDeliveryFee,
          monthlyFee: this.editedMonthlyFee,
          weeklyFee: this.editedWeeklyFee,
          category: this.editedCategory,
          area: this.editedArea,
          location: this.editedLocation,
          minDays: this.editedMinDays,
          condition: this.editedCondition,
          images: this.item.images,
          availabilty: this.availabilty,
        })
        // TODO
        .then(() => {
          this.showLoadingForUpdateItem = false;
          this.dialog = false;
          // this.$router.go();
        })
        .catch((err) => {
          //handle error
          this.showLoadingForCreateItem = false;
        });
    },
    deleteItem(doc) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          firebase
            .firestore()
            .collection("items")
            .doc(doc.id)
            .delete()
            .then(() => {
              Toast.fire({
                title: "Deleted successfully",
              });
              var remainingItems = this.$store.getters.loadedItems.filter(
                (item) => {
                  return item.id != doc.id;
                }
              );
              this.$store.commit("setLoadedItems", remainingItems);
              this.$router.push("/dashboard");
            })
            .catch((err) => {
              console.log(err);
              Toast.fire({
                title: "Can't Delete Item.",
              });
            });
        }
      });
    },
    removeItem(item) {
      db.collection("items")
        .doc("item.id")
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
};
</script>

<template>
  <v-container style="padding-top: 0px; max-width: 1096px">
    <template v-if="item">
      <v-row style="padding: 16px">
        <v-col cols="12" md="7">
          <v-container>
            <v-row>
              <v-icon color="black" @click="$router.go(-1)"
                >fas fa-arrow-left</v-icon
              >
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card outlined style="border-radius: 12px">
                  <v-img
                    rounded
                    :src="selectedImage"
                    height="40vh"
                    width="100%"
                    style="border-radius: 12px"
                    @click="showDialog = true"
                  />
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-for="(v, k) in item.images" :key="k" cols="12" sm="2">
                <v-hover>
                  <template v-slot="{ hover }">
                    <v-card
                      outlined
                      :color="v === selectedImage ? 'secondary' : ''"
                      @click="changeSelectedImage(v)"
                      style="border-radius: 12px"
                    >
                      <v-img
                        rounded
                        :src="v"
                        height="10vh"
                        style="border-radius: 12px"
                      />
                      <v-overlay
                        @click.stop="showDialog = true"
                        v-if="hover"
                        absolute
                      >
                        <v-icon large> mdi-arrow-expand-all </v-icon>
                      </v-overlay>
                    </v-card>
                  </template>
                </v-hover>
              </v-col>
            </v-row>

            <v-dialog v-model="showDialog" width="500">
              <v-card>
                <v-carousel hide-delimiters>
                  <v-carousel-item
                    v-for="(v, k) in item.images"
                    :key="k"
                    :src="v"
                  ></v-carousel-item>
                </v-carousel>
              </v-card>
            </v-dialog>
            <v-row style="padding: 12px" class="hidden-sm-and-down">
              <v-card
                class="pa-6 center"
                style="
                  border-radius: 13px;
                  padding: 16px !important;
                  width: 100%;
                "
                elevation="4"
              >
                <v-row class="mt-3">
                  <!-- <v-col cols="12" lg="2" md="12"> -->
                  <v-avatar outline size="100">
                    <!-- <div > -->
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ avatar }}
                    </p>
                    <v-img v-if="hasAvatar" :src="avatarPic"></v-img>
                    <!-- </div> -->
                    <svg
                      v-else
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                      style="fill: currentcolor"
                      aria-hidden="true"
                      role="presentation"
                      focusable="false"
                    >
                      <path
                        d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                      ></path>
                    </svg>
                  </v-avatar>
                  <!-- </v-col> -->
                  <!-- <v-col  cols="12" lg="6" md="12"> -->
                  <div
                    class="font-weight-bold h2"
                    style="
                      color: black;
                      margin-left: 10px;
                      text-align: left;
                      justify: left;
                    "
                  >
                    <svg
                      height="20px"
                      width="20px"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fad"
                      data-icon="location-dot"
                      class="svg-inline--fa fa-location-dot"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                    >
                      <g class="fa-group">
                        <path
                          class="fa-secondary"
                          fill="#F8955B"
                          d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                        ></path>
                        <path
                          class="fa-primary"
                          fill="#b22af0"
                          d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                        ></path>
                      </g>
                    </svg>
                    {{ item.created_by }}
                    in {{ item.suburb }}
                    <br />
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ strappDate }}
                    </p>
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ isVerified }}
                    </p>
                    <h5
                      class="text"
                      style="
                        margin-left: 10px;
                        font-weight: normal !important;
                        color: black;
                      "
                      v-if="startDate != null"
                    >
                      Active since {{ startDate }}
                    </h5>
                    <br />
                    <v-row
                      v-if="verified === true"
                      class="mt-6"
                      style="
                        align-items: left;
                        margin-top: 0px !important;
                        margin-left: 8px;
                      "
                    >
                      <svg
                        :style="
                          $vuetify.breakpoint.xsOnly
                            ? 'height: 10px; width: 10px; margin-right 5px !important;'
                            : '' && $vuetify.breakpoint.smAndDown
                            ? 'height: 30px; width: 30px; margin-right 5px !important;'
                            : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                              $vuetify.breakpoint.mdAndUp
                            ? 'height: 18px; width: 18px; margin-right 5px !important;'
                            : 'height: 12px; width: 12px; margin-right 5px !important;'
                        "
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="user-shield"
                        class="svg-inline--fa fa-user-shield fa-w-20"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="#b22af0"
                            d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                          ></path>
                          <path
                            class="fa-primary"
                            fill="#F29E4D"
                            d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                          ></path>
                        </g>
                      </svg>
                      <h5
                        style="
                          color: black;
                          margin-left: 5px;
                          margin-right: 15px;
                        "
                      >
                        Verified
                      </h5>

                      <svg
                        :style="
                          $vuetify.breakpoint.xsOnly
                            ? 'height: 10px; width: 10px; margin-right 5px !important;'
                            : '' && $vuetify.breakpoint.smAndDown
                            ? 'height: 30px; width: 30px; margin-right 5px !important;'
                            : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                              $vuetify.breakpoint.mdAndUp
                            ? 'height: 18px; width: 18px; margin-right 5px !important;'
                            : 'height: 12px; width: 12px; margin-right 5px !important;'
                        "
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="handshake"
                        class="svg-inline--fa fa-handshake fa-w-20"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="#b22af0"
                            d="M480 128.2c-40.98-40.93-64.6-64.12-122.6-64.12c-10.49 0-19.93-.6141-30.2 8.566L217 163.6C196.8 180.7 194.2 210.1 211.4 231.2c9.5 11.21 23.03 16.99 36.67 16.99c10.94 0 21.95-3.716 30.97-11.33l39.57-33.46l165.3 135.3c4.361 3.536 7.123 8.173 9.078 13.04L544 351.1V128.4L480 128.2zM0 383.9l64 .0404c17.75 0 32-14.3 32-32.03V128.3L0 128.3V383.9zM48 320.1c8.75 0 16 7.124 16 15.99c0 8.735-7.25 15.99-16 15.99S32 344.8 32 336.1C32 327.2 39.25 320.1 48 320.1z"
                          ></path>
                          <path
                            class="fa-primary"
                            fill="#F09F54"
                            d="M318.6 203.4L279 236.8c-9.016 7.619-20.03 11.33-30.97 11.33c-13.64 0-27.17-5.777-36.67-16.99C194.2 210.1 196.8 180.7 217 163.6l110.3-90.9L280.9 64C223.6 64.37 168.8 87.48 128.2 127.9L96 128.3v223.6l50.25-.0904l90.5 81.82c27.5 22.35 67.75 18.1 90-9.246l18.12 15.24c15.88 12.98 39.38 10.48 52.38-5.371l31.38-38.6l5.374 4.498c13.75 10.99 33.88 8.991 45-4.748l9.538-11.78c11.08-13.69 8.985-33.83-4.694-44.93L318.6 203.4zM544 128.4v223.6c0 17.6 14.25 32.05 31.1 32.05L640 384V128.5L544 128.4zM592 352c-8.75 0-16-7.253-16-15.99c0-8.868 7.25-15.99 16-15.99s16 7.124 16 15.99C608 344.8 600.8 352 592 352z"
                          ></path>
                        </g>
                      </svg>
                      <!-- <h5 style="color: black; margin-left: 5px">
                        Reviews: {{ rateItems }}
                      </h5> -->
                    </v-row>

                    <v-row
                      v-else
                      class="mt-6"
                      style="
                        align-items: left;
                        margin-top: 0px !important;
                        margin-left: 8px;
                      "
                    >
                      <svg
                        :style="
                          $vuetify.breakpoint.xsOnly
                            ? 'height: 10px; width: 10px; margin-right 5px !important;'
                            : '' && $vuetify.breakpoint.smAndDown
                            ? 'height: 30px; width: 30px; margin-right 5px !important;'
                            : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                              $vuetify.breakpoint.mdAndUp
                            ? 'height: 18px; width: 18px; margin-right 5px !important;'
                            : 'height: 12px; width: 12px; margin-right 5px !important;'
                        "
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="user-shield"
                        class="svg-inline--fa fa-user-shield fa-w-20"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="#b22af0"
                            d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                          ></path>
                          <path
                            class="fa-primary"
                            fill="#F29E4D"
                            d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                          ></path>
                        </g>
                      </svg>
                      <h5
                        style="
                          color: black;
                          margin-left: 5px;
                          margin-right: 15px;
                        "
                      >
                        Not Verified
                      </h5>

                      <svg
                        :style="
                          $vuetify.breakpoint.xsOnly
                            ? 'height: 10px; width: 10px; margin-right 5px !important;'
                            : '' && $vuetify.breakpoint.smAndDown
                            ? 'height: 30px; width: 30px; margin-right 5px !important;'
                            : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                              $vuetify.breakpoint.mdAndUp
                            ? 'height: 18px; width: 18px; margin-right 5px !important;'
                            : 'height: 12px; width: 12px; margin-right 5px !important;'
                        "
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="handshake"
                        class="svg-inline--fa fa-handshake fa-w-20"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="#b22af0"
                            d="M480 128.2c-40.98-40.93-64.6-64.12-122.6-64.12c-10.49 0-19.93-.6141-30.2 8.566L217 163.6C196.8 180.7 194.2 210.1 211.4 231.2c9.5 11.21 23.03 16.99 36.67 16.99c10.94 0 21.95-3.716 30.97-11.33l39.57-33.46l165.3 135.3c4.361 3.536 7.123 8.173 9.078 13.04L544 351.1V128.4L480 128.2zM0 383.9l64 .0404c17.75 0 32-14.3 32-32.03V128.3L0 128.3V383.9zM48 320.1c8.75 0 16 7.124 16 15.99c0 8.735-7.25 15.99-16 15.99S32 344.8 32 336.1C32 327.2 39.25 320.1 48 320.1z"
                          ></path>
                          <path
                            class="fa-primary"
                            fill="#F09F54"
                            d="M318.6 203.4L279 236.8c-9.016 7.619-20.03 11.33-30.97 11.33c-13.64 0-27.17-5.777-36.67-16.99C194.2 210.1 196.8 180.7 217 163.6l110.3-90.9L280.9 64C223.6 64.37 168.8 87.48 128.2 127.9L96 128.3v223.6l50.25-.0904l90.5 81.82c27.5 22.35 67.75 18.1 90-9.246l18.12 15.24c15.88 12.98 39.38 10.48 52.38-5.371l31.38-38.6l5.374 4.498c13.75 10.99 33.88 8.991 45-4.748l9.538-11.78c11.08-13.69 8.985-33.83-4.694-44.93L318.6 203.4zM544 128.4v223.6c0 17.6 14.25 32.05 31.1 32.05L640 384V128.5L544 128.4zM592 352c-8.75 0-16-7.253-16-15.99c0-8.868 7.25-15.99 16-15.99s16 7.124 16 15.99C608 344.8 600.8 352 592 352z"
                          ></path>
                        </g>
                      </svg>
                      <!-- <h5 style="color: black; margin-left: 5px">
                        Reviews: {{ rateItems }}
                      </h5> -->
                    </v-row>
                  </div>
                </v-row>

                <v-row class="mb-3">
                  <v-btn
                    v-bind="size"
                    class="appbuttonSecondary mx-1 mt-1 font-weight-medium"
                    color="#b22af0"
                    rounded
                    style="margin-top: 30px !important"
                    elevation="6"
                    @click="$router.push('/profile/' + item.userID)"
                    z-index="12"
                  >
                    <v-icon x-small class="mr-1">fas fa-user</v-icon>View
                    Profile
                  </v-btn>

                  <v-btn
                    v-if="!userIsCreator"
                    v-bind="size"
                    class="appbutton mx-1 mt-3 white--text font-weight-medium"
                    color="#b22af0"
                    rounded
                    style="margin-top: 30px !important"
                    elevation="6"
                    @click="toInbox()"
                    z-index="12"
                  >
                    Message Lender<v-icon x-small class="ml-1"
                      >fas fa-chevron-right</v-icon
                    >
                  </v-btn>
                </v-row>
                <!-- </v-col> -->
              </v-card>
            </v-row>
          </v-container>
        </v-col>

        <v-col cols="12" md="5">
          <v-col>
            <v-row>
              <h2
                :class="[$vuetify.breakpoint.mdAndUp ? 'h6' : 'title']"
                class="ml-5 font-weight-bold accent--text"
              >
                {{ item.itemName || this.editedTitle }}
              </h2>
            </v-row>
            <v-row>
              <p class="ml-5 font-weight-light accent--text">
                R{{ item.price }}
              </p>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
            </v-row>
            <v-btn :to="'/salesItemPurchase/' + item.id" block color="accent"
              >Buy</v-btn
            >
            <v-row class="my-1">
              <v-col cols="auto">
                <v-icon small>mdi-clock-outline</v-icon>
              </v-col>
              <v-col cols="auto">
                <span>1 mon</span>
              </v-col>
              <v-col cols="auto">
                <v-icon small>mdi-map-marker-outline</v-icon>
              </v-col>
              <v-col cols="auto">
                <span>{{ item.location }}</span>
              </v-col>
            </v-row>
            <p class="subtitle-1">
              {{ item.itemDescription }}
            </p>
          </v-col>
          <!-- <div
            class="font-weight-bold h2 secondary--text"
            style="
              margin-left: 24px;
              margin-top: 8px;
              text-align: left;
              justify: left;
            "
          >
            <svg
              height="20px"
              width="20px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="location-dot"
              class="svg-inline--fa fa-location-dot"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#F8955B"
                  d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                ></path>
                <path
                  class="fa-primary secondary--text"
                  d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                ></path>
              </g>
            </svg>

            {{ item.area }}
          </div> -->

          <v-container>
            <v-row>
              <v-col cols="12" md="6" v-if="item.condition">
                <v-card class="pa-5 mt-3" outlined style="border-radius: 13px">
                  <p class="subtitle-1">
                    Condition:
                    <span class="font-weight-bold">
                      {{ item.condition.split(",")[0] }}</span
                    >
                  </p>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-row class="d-flex justify-center">
                  <v-col
                    v-for="(item, index) in items"
                    :key="index"
                    cols="4"
                    class="grid"
                  >
                    <v-row>
                      <v-btn icon @click="handleAction(item.action)">
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-btn>
                    </v-row>
                    <v-row>
                      <span class="caption">{{ item.text }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" v-if="item.minPeriod">
                <v-card class="pa-5 mt-3" outlined style="border-radius: 13px">
                  <p class="subtitle-1">
                    Minimum rental Period:
                    <span class="font-weight-bold">{{ item.minPeriod }}</span>
                  </p>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <!-- ITEM REVIEWS -->

          <v-row v-if="item.rating_count >= 1" style="padding: 12px">
            <v-card
              class="pa-3"
              style="
                border-radius: 13px;
                padding: 16px !important;
                width: 100%;
                max-height: 225px !important;
                overflow-y: scroll;
              "
              elevation="4"
            >
              <v-row
                class="font-weight-bold h2"
                style="justify-content: center"
              >
                <!-- <div

                    style="
                      color: black;
                  text-align: center;
                  width: 100%;
                    "
                  > -->
                Reviews: {{ item.rating_count }} Rating:
                <template v-if="item.rating_count >= 1">
                  <p style="margin-left: 8px !important">
                    {{ Math.round(item.rating * 100) / 100 }}
                  </p>
                  <svg
                    aria-hidden="true"
                    height="20px"
                    width="20px"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="star"
                    class="svg-inline--fa fa-star mx-1"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="gold"
                        d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                      ></path>
                      <path class="fa-primary" fill="gold" d=""></path>
                    </g>
                  </svg>

                  <!-- <p class="grey--text">({{ item.rating_count }})</p> -->
                </template>
              </v-row>
              <v-row v-for="review in reviews" :key="review.id">
                <!-- <v-col cols="12" lg="2" md="12"> -->

                <!-- </v-col> -->
                <!-- <v-col  cols="12" lg="6" md="12"> -->
                <div
                  class="font-weight-bold h2"
                  style="
                    color: black;
                    padding: 8px;
                    text-align: left;
                    justify: left;
                    width: 100%;
                    border-top: 1px solid #e0e0e0;
                    padding-top: 16px;
                  "
                >
                  <v-row>
                    <v-col style="padding: 8px" cols="2" lg="1" xl="1" md="2">
                      <v-avatar outline size="40">
                        <!-- <div > -->
                        <p class="hidden-sm-and-down hidden-md-and-up">
                          {{ review.reviewerAvatar }}
                        </p>
                        <v-img
                          v-if="review.reviewerAvatar != null"
                          :src="review.reviewerAvatar"
                        ></v-img>
                        <!-- </div> -->
                        <svg
                          v-else
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                          style="fill: currentcolor"
                          aria-hidden="true"
                          role="presentation"
                          focusable="false"
                        >
                          <path
                            d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                          ></path>
                        </svg>
                      </v-avatar>
                    </v-col>
                    <v-col style="padding: 4px" cols="7" lg="8" xl="8" md="7">
                      <p
                        style="
                          float: center !important;
                          font-weight: normal;
                          color: black;
                          margin: 0px !important;
                          margin-left: 2px !important;
                        "
                      >
                        {{ review.borrowerName }}
                      </p>

                      <v-rating
                        class="ma-4"
                        length="5"
                        dense
                        readonly
                        :value="review.rating"
                        color="yellow darken-2"
                        style="margin: 0px !important"
                      ></v-rating>
                    </v-col>
                    <v-col style="padding: 4px" cols="3" lg="3" xl="3" md="3">
                      <p
                        style="
                          float: left !important;
                          font-weight: normal;
                          color: grey;
                          font-size: 12px !important;
                        "
                      >
                        {{ review.date }}
                      </p>
                    </v-col>
                  </v-row>

                  <!-- <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ strappDate }}
                    </p>
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ isVerified }}
                    </p> -->
                  <v-row>
                    <v-col
                      style="padding: 4px"
                      cols="2"
                      lg="1"
                      xl="1"
                      md="2"
                    ></v-col>
                    <v-col
                      style="padding: 4px"
                      cols="10"
                      lg="11"
                      xl="11"
                      md="10"
                    >
                      <h5
                        class="text"
                        style="
                          margin-left: 2px;
                          font-weight: normal !important;
                          color: black;
                        "
                      >
                        {{ review.review }}
                      </h5>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
            </v-card>
          </v-row>
          <v-alert
            border="bottom"
            colored-border
            type="info"
            color="tan"
            elevation="2"
            class="my-6 text-caption text-md-body-1"
            v-if="bp1"
            @input="bp1 = false"
            dismissible
          >
            All transactions made through Strapp are protected. Once you make
            the payment, we hold your money safely and only release it to the
            lender after youve told us you received the item. Please Note : we
            can only protect you when you use the Strapp payment gateway.
            Transactions made outside of Strapp are not protected.
          </v-alert>
          <v-row class="grid my-4">
            <v-card
              style="max-width: 500px"
              outlined
              class="pa-2 round"
              color="#A7C0FF"
            >
              <v-row>
                <v-col
                  cols="2"
                  class="center"
                  style="padding: 0px; justify-content: center"
                >
                  <!-- <div > -->
                  <v-img
                    style="
                      max-height: 50px;
                      max-width: 40px;
                      width: 70%;
                      margin: 15% !important;
                    "
                    :src="require('@/assets/fontawesome/lock-duotone.svg')"
                  />
                  <!-- </div> -->
                </v-col>

                <v-col class="center">
                  <p style="font-size: 15px; text-align: center; margin: 0px">
                    Get our
                    <b
                      style="
                        color: #b22af0;
                        text-decoration: underline;
                        cursor: pointer;
                      "
                      @click="bp1 = true"
                    >
                      Borrower Protection</b
                    >
                    when you rent with Strapp!
                  </p>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
          <div class="my-6"></div>
          <v-row style="padding: 12px" class="hidden-md-and-up">
            <v-card
              class="pa-6 center"
              style="border-radius: 13px; padding: 16px !important; width: 100%"
              elevation="4"
            >
              <v-row class="mt-3 center">
                <!-- <v-col cols="12" lg="2" md="12"> -->
                <v-avatar outline size="100">
                  <!-- <div > -->
                  <p class="hidden-sm-and-down hidden-md-and-up">
                    {{ avatar }}
                  </p>
                  <v-img v-if="hasAvatar" :src="avatarPic"></v-img>
                  <!-- </div> -->
                  <svg
                    v-else
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                    style="fill: currentcolor"
                    aria-hidden="true"
                    role="presentation"
                    focusable="false"
                  >
                    <path
                      d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                    ></path>
                  </svg>
                </v-avatar>
                <!-- </v-col> -->
                <!-- <v-col  cols="12" lg="6" md="12"> -->
                <div
                  class="font-weight-bold h2"
                  style="
                    color: black;
                    margin-left: 10px;
                    text-align: left;
                    justify: left;
                  "
                >
                  <svg
                    height="20px"
                    width="20px"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="location-dot"
                    class="svg-inline--fa fa-location-dot"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="#F8955B"
                        d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                      ></path>
                      <path
                        class="fa-primary"
                        fill="#b22af0"
                        d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                      ></path>
                    </g>
                  </svg>
                  {{ item.created_by }}
                  in {{ item.suburb }}
                  <br />
                  <p class="hidden-sm-and-down hidden-md-and-up">
                    {{ strappDate }}
                  </p>
                  <p class="hidden-sm-and-down hidden-md-and-up">
                    {{ isVerified }}
                  </p>
                  <h5
                    class="text"
                    style="
                      margin-left: 10px;
                      font-weight: normal !important;
                      color: black;
                    "
                    v-if="startDate != null"
                  >
                    Active since {{ startDate }}
                  </h5>
                  <br />
                  <v-row
                    v-if="verified === true"
                    class="mt-6"
                    style="
                      align-items: left;
                      margin-top: 0px !important;
                      margin-left: 8px;
                    "
                  >
                    <svg
                      :style="
                        $vuetify.breakpoint.xsOnly
                          ? 'height: 10px; width: 10px; margin-right 5px !important;'
                          : '' && $vuetify.breakpoint.smAndDown
                          ? 'height: 30px; width: 30px; margin-right 5px !important;'
                          : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                            $vuetify.breakpoint.mdAndUp
                          ? 'height: 18px; width: 18px; margin-right 5px !important;'
                          : 'height: 12px; width: 12px; margin-right 5px !important;'
                      "
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fad"
                      data-icon="user-shield"
                      class="svg-inline--fa fa-user-shield fa-w-20"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <g class="fa-group">
                        <path
                          class="fa-secondary"
                          fill="#b22af0"
                          d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                        ></path>
                        <path
                          class="fa-primary"
                          fill="#F29E4D"
                          d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                        ></path>
                      </g>
                    </svg>
                    <h5
                      style="color: black; margin-left: 5px; margin-right: 15px"
                    >
                      Verified
                    </h5>

                    <svg
                      :style="
                        $vuetify.breakpoint.xsOnly
                          ? 'height: 10px; width: 10px; margin-right 5px !important;'
                          : '' && $vuetify.breakpoint.smAndDown
                          ? 'height: 30px; width: 30px; margin-right 5px !important;'
                          : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                            $vuetify.breakpoint.mdAndUp
                          ? 'height: 18px; width: 18px; margin-right 5px !important;'
                          : 'height: 12px; width: 12px; margin-right 5px !important;'
                      "
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fad"
                      data-icon="handshake"
                      class="svg-inline--fa fa-handshake fa-w-20"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <g class="fa-group">
                        <path
                          class="fa-secondary"
                          fill="#b22af0"
                          d="M480 128.2c-40.98-40.93-64.6-64.12-122.6-64.12c-10.49 0-19.93-.6141-30.2 8.566L217 163.6C196.8 180.7 194.2 210.1 211.4 231.2c9.5 11.21 23.03 16.99 36.67 16.99c10.94 0 21.95-3.716 30.97-11.33l39.57-33.46l165.3 135.3c4.361 3.536 7.123 8.173 9.078 13.04L544 351.1V128.4L480 128.2zM0 383.9l64 .0404c17.75 0 32-14.3 32-32.03V128.3L0 128.3V383.9zM48 320.1c8.75 0 16 7.124 16 15.99c0 8.735-7.25 15.99-16 15.99S32 344.8 32 336.1C32 327.2 39.25 320.1 48 320.1z"
                        ></path>
                        <path
                          class="fa-primary"
                          fill="#F09F54"
                          d="M318.6 203.4L279 236.8c-9.016 7.619-20.03 11.33-30.97 11.33c-13.64 0-27.17-5.777-36.67-16.99C194.2 210.1 196.8 180.7 217 163.6l110.3-90.9L280.9 64C223.6 64.37 168.8 87.48 128.2 127.9L96 128.3v223.6l50.25-.0904l90.5 81.82c27.5 22.35 67.75 18.1 90-9.246l18.12 15.24c15.88 12.98 39.38 10.48 52.38-5.371l31.38-38.6l5.374 4.498c13.75 10.99 33.88 8.991 45-4.748l9.538-11.78c11.08-13.69 8.985-33.83-4.694-44.93L318.6 203.4zM544 128.4v223.6c0 17.6 14.25 32.05 31.1 32.05L640 384V128.5L544 128.4zM592 352c-8.75 0-16-7.253-16-15.99c0-8.868 7.25-15.99 16-15.99s16 7.124 16 15.99C608 344.8 600.8 352 592 352z"
                        ></path>
                      </g>
                    </svg>
                    <!-- <h5 style="color: black; margin-left: 5px">
                      Reviews: {{ rateItems }}
                    </h5> -->
                  </v-row>

                  <v-row
                    v-else
                    class="mt-6"
                    style="
                      align-items: left;
                      margin-top: 0px !important;
                      margin-left: 8px;
                    "
                  >
                    <svg
                      :style="
                        $vuetify.breakpoint.xsOnly
                          ? 'height: 10px; width: 10px; margin-right 5px !important;'
                          : '' && $vuetify.breakpoint.smAndDown
                          ? 'height: 30px; width: 30px; margin-right 5px !important;'
                          : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                            $vuetify.breakpoint.mdAndUp
                          ? 'height: 18px; width: 18px; margin-right 5px !important;'
                          : 'height: 12px; width: 12px; margin-right 5px !important;'
                      "
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fad"
                      data-icon="user-shield"
                      class="svg-inline--fa fa-user-shield fa-w-20"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <g class="fa-group">
                        <path
                          class="fa-secondary"
                          fill="#b22af0"
                          d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                        ></path>
                        <path
                          class="fa-primary"
                          fill="#F29E4D"
                          d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                        ></path>
                      </g>
                    </svg>
                    <h5
                      style="color: black; margin-left: 5px; margin-right: 15px"
                    >
                      Not Verified
                    </h5>

                    <svg
                      :style="
                        $vuetify.breakpoint.xsOnly
                          ? 'height: 10px; width: 10px; margin-right 5px !important;'
                          : '' && $vuetify.breakpoint.smAndDown
                          ? 'height: 30px; width: 30px; margin-right 5px !important;'
                          : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                            $vuetify.breakpoint.mdAndUp
                          ? 'height: 18px; width: 18px; margin-right 5px !important;'
                          : 'height: 12px; width: 12px; margin-right 5px !important;'
                      "
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fad"
                      data-icon="handshake"
                      class="svg-inline--fa fa-handshake fa-w-20"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <g class="fa-group">
                        <path
                          class="fa-secondary"
                          fill="#b22af0"
                          d="M480 128.2c-40.98-40.93-64.6-64.12-122.6-64.12c-10.49 0-19.93-.6141-30.2 8.566L217 163.6C196.8 180.7 194.2 210.1 211.4 231.2c9.5 11.21 23.03 16.99 36.67 16.99c10.94 0 21.95-3.716 30.97-11.33l39.57-33.46l165.3 135.3c4.361 3.536 7.123 8.173 9.078 13.04L544 351.1V128.4L480 128.2zM0 383.9l64 .0404c17.75 0 32-14.3 32-32.03V128.3L0 128.3V383.9zM48 320.1c8.75 0 16 7.124 16 15.99c0 8.735-7.25 15.99-16 15.99S32 344.8 32 336.1C32 327.2 39.25 320.1 48 320.1z"
                        ></path>
                        <path
                          class="fa-primary"
                          fill="#F09F54"
                          d="M318.6 203.4L279 236.8c-9.016 7.619-20.03 11.33-30.97 11.33c-13.64 0-27.17-5.777-36.67-16.99C194.2 210.1 196.8 180.7 217 163.6l110.3-90.9L280.9 64C223.6 64.37 168.8 87.48 128.2 127.9L96 128.3v223.6l50.25-.0904l90.5 81.82c27.5 22.35 67.75 18.1 90-9.246l18.12 15.24c15.88 12.98 39.38 10.48 52.38-5.371l31.38-38.6l5.374 4.498c13.75 10.99 33.88 8.991 45-4.748l9.538-11.78c11.08-13.69 8.985-33.83-4.694-44.93L318.6 203.4zM544 128.4v223.6c0 17.6 14.25 32.05 31.1 32.05L640 384V128.5L544 128.4zM592 352c-8.75 0-16-7.253-16-15.99c0-8.868 7.25-15.99 16-15.99s16 7.124 16 15.99C608 344.8 600.8 352 592 352z"
                        ></path>
                      </g>
                    </svg>
                    <!-- <h5 style="color: black; margin-left: 5px">
                      Reviews: {{ rateItems }}
                    </h5> -->
                  </v-row>
                </div>
              </v-row>

              <!-- </v-col>
       <v-col cols="12" lg="4" md="12"> -->
              <v-row class="mb-3 center">
                <v-btn
                  v-bind="size"
                  class="appbuttonSecondary mx-1 mt-1 font-weight-medium"
                  color="#b22af0"
                  rounded
                  style="margin-top: 30px !important"
                  elevation="6"
                  @click="$router.push('/profile/' + item.userID)"
                  z-index="12"
                >
                  <v-icon x-small class="mr-1">fas fa-user</v-icon>View Profile
                </v-btn>

                <v-btn
                  v-if="!userIsCreator"
                  v-bind="size"
                  class="appbutton mx-1 mt-3 white--text font-weight-medium"
                  color="#b22af0"
                  rounded
                  elevation="6"
                  @click="toInbox()"
                  z-index="12"
                >
                  Message Lender<v-icon x-small class="ml-1"
                    >fas fa-chevron-right</v-icon
                  >
                </v-btn>
              </v-row>
              <!-- </v-col> -->
            </v-card>
          </v-row>
          <rentalInfo />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<style>
.selected-image {
  border-color: blue; /* Apply a different color outline to the selected image */
}

/* Hide scrollba
/* Hide scrollbar for Chrome, Safari and Opera */
.scroll::-webkit-scrollbar {
  display: none;
  overflow-x: hidden;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scroll {
  -ms-overflow-style: none;
  /* IE and Edge */
  overflow-x: hidden;
  /* Hide horizontal scrollbar */
  scrollbar-width: none;
  /* Firefox */
}

.input {
  border-radius: 12px;
}

.tooltip {
  background: rgb(255, 255, 255) !important;
  width: 400px !important;
  max-width: 100% !important;
  max-height: 100% !important;
  position: absolute;
  z-index: 9;
}

.card {
  border-color: #a2a6ac;
  border-radius: 8px;
}

.text {
  color: #fff;
  /* margin: 5px; */
  text-align: "left";
}

.card:hover {
  border-radius: 8px;
  border-color: rgb(34, 34, 34);
}

.Sbutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  width: 10rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.Sbutton:hover {
  width: 11rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

/* .boxx {

} */

.boxx-shadow:after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: 1px;
  z-index: -1;
  transform: scale(0.9);
  box-shadow: 0px 0px 8px 2px #000000;
}

.Ebutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  width: 60%;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.Ebutton:hover {
  width: 21rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

.image-div {
  display: flex;
  margin: 25px;
}

.image {
  max-width: 250px;
  margin: 15px;
}

.center {
  display: grid;
  place-items: center;
}
</style>
